import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuex from 'vuex';
import router from './routes';
import App from './components/App.vue';
import store from './store';
import Roles from './mixins/Roles.vue';
import axios from './plugins/axios';
import Permissions from './mixins/Permissions.vue';
import VueSweetAlert2 from 'vue-sweetalert2';
import Vuetify from '../plugins/vuetify'
import 'sweetalert2/dist/sweetalert2.min.css';
import VueHtml2Canvas from 'vue-html2canvas';
import JsonExcel from "vue-json-excel";
import "regenerator-runtime";
import VueGoogleCharts from 'vue-google-charts';

Vue.use(Vuetify);
Vue.use(Vuex);
Vue.use(VueSweetAlert2);
Vue.use(VueHtml2Canvas);
Vue.use(VueGoogleCharts);
Vue.mixin(Roles);
Vue.mixin(Permissions);

Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('JsBarcode', require('jsbarcode'));
Vue.component("downloadExcel", JsonExcel);
window.axios = axios;

new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    vuetify: Vuetify,
    components: {
        App,
    },
    watch: {
        $route: {
            async handler() {
                if (this.$route.meta.requiresAuth) {
                    await this.$store.dispatch('auth/fetchUser');
                    await this.$store.dispatch('auth/fetchAbilities');
                }
            }
        },
        immediate: true
    }
})
